import branchManagementCancelledShipmentsComponent from './cancelled_shipments.component';

let branchManagementCancelledShipmentsModule = angular.module('branchManagementCancelledShipments', [])
    .component('branchManagementCancelledShipments', branchManagementCancelledShipmentsComponent)
    .name;

export default branchManagementCancelledShipmentsModule


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/cancelled_shipments/index.js